import type { Country } from '@/api/lookup/types';

export function resolveCountryId(countries: Country[], value: string | null | undefined): string {
  const needle = value?.trim().toLowerCase();
  if (!needle) return '';

  return (
    countries.find(
      (country) =>
        country.id.toLowerCase() === needle || country.name.trim().toLowerCase() === needle,
    )?.id ?? ''
  );
}
